<script lang="ts">
	import { Link } from 'svelte-routing';
	import TopAppBar, { Row, Section, Title } from '@smui/top-app-bar/styled';
	import Menu from '@smui/menu/styled';
	import { Anchor } from '@smui/menu-surface/styled';
	import List, { Item, Separator, Text, PrimaryText, SecondaryText } from '@smui/list/styled';
	import IconButton from '@smui/icon-button/styled';
	import { createEventDispatcher } from 'svelte';
	import { userClientData } from '../stores';
	import { APP_PATHS } from '../constants';
	import { userManager, userInfo } from '../stores';
	import { dateFormatter } from '../utils';
	import Avatar from '../components/Users/Avatar.svelte';

	const dispatch = createEventDispatcher();
	let userAnchor: HTMLElement;
	let userMenu: Menu;

	function toggleDrawer(event: Event) {
		dispatch('menuclick', event);
	}
</script>

<TopAppBar color="secondary" variant="fixed">
	<Row>
		<Section>
			<IconButton on:click={toggleDrawer} class="material-icons">menu</IconButton>
			<Title>{$userClientData.webData.appTitle}</Title>
		</Section>
		<Section align="end" toolbar>
			<div use:Anchor bind:this={userAnchor}>
				<Avatar imageSrc={$userInfo.googleProfilePic} on:click={() => userMenu.setOpen(true)} />
				<Menu
					bind:this={userMenu}
					anchor={false}
					bind:anchorElement={userAnchor}
					anchorCorner="BOTTOM_LEFT"
				>
					<List twoLine>
						<div class="user-basic-item">
							<PrimaryText>{$userInfo.email}</PrimaryText>
							{#if $userInfo.googleName}
								<SecondaryText>{$userInfo.googleName}</SecondaryText>
							{/if}
							<SecondaryText>Registered: {dateFormatter($userInfo.createdAt)}</SecondaryText>
							<!-- This `if` can be removed in the future.
                            For now it avoids error for logged user without new version -->
							{#if $userInfo.client}
								<SecondaryText>Client: {$userInfo.client.name}</SecondaryText>
							{/if}
							<br />
							<Link on:click={() => userMenu.setOpen(false)} to={APP_PATHS.PREFERENCES}
								>Settings</Link
							>
							{#if $userInfo.role === 'ADMIN' || $userInfo.role === 'SUPERADMIN'}
								<br />
								<Link on:click={() => userMenu.setOpen(false)} to={APP_PATHS.USER_MANAGEMENT}
									>User management</Link
								>
							{/if}
						</div>
						<Separator />
						<Item on:SMUI:action={userManager.logOff}>
							<Text>
								<PrimaryText>Log out</PrimaryText>
								<SecondaryText>Bye :(</SecondaryText>
							</Text>
						</Item>
					</List>
				</Menu>
			</div>
		</Section>
	</Row>
</TopAppBar>

<style>
	.user-basic-item {
		padding: 26px 16px;
	}
</style>
